const resolveTerm = (term) => {
  const termsInState = window.$nuxt.$store.getters['plataforma/terms/getTerms'] || [];
  const termInState = termsInState.find(item => item.termId === term);
  if (termInState) {
    const customTerm = termInState.customTerms
      .find(item => item.language.toLocaleLowerCase() === window.$nuxt.$i18n.locale.toLocaleLowerCase());
    if (customTerm && customTerm.name) {
      return customTerm.name;
    }
  }
  return window.$nuxt.$t(`terms.${term}`);
};

export {
  resolveTerm
};
